function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 63.167,
  cy: 63.167,
  r: 61.667,
  stroke: "#fff",
  strokeWidth: 3
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M63.824 74.572c3.974 0 7.194-3.143 7.194-7.019 0-3.876-3.22-7.018-7.194-7.018-3.973 0-7.194 3.142-7.194 7.018s3.221 7.019 7.194 7.019zM72.817 44.15c5.8 0 10.499 4.585 10.499 10.243h2.99c0-7.26-6.048-13.16-13.49-13.16v2.918zm0 5.857c2.495 0 4.496 1.952 4.496 4.386h2.99c0-4.035-3.35-7.303-7.486-7.303v2.917z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M75.065 56.587c0-2.435-2-4.387-4.496-4.387v-6.58H57.08l-4.114 4.387h-7.127c-2.472 0-4.496 1.974-4.496 4.386v26.32c0 2.412 2.024 4.386 4.496 4.386h35.97c2.473 0 4.497-1.974 4.497-4.386V56.587H75.065zm-11.24 21.932c-6.205 0-11.241-4.912-11.241-10.966 0-6.053 5.036-10.966 11.24-10.966 6.205 0 11.241 4.913 11.241 10.966 0 6.054-5.036 10.966-11.24 10.966z",
  fill: "#fff"
});

const SvgCameraCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 127 127",
  fill: "none"
}, props), _ref, _ref2, _ref3);

export default SvgCameraCircle;